/**
 * CSRF token source (ADR 0008 section 3, internal/portal/session.go):
 * double-submit pattern. The BFF sets a non-HttpOnly `mft_csrf` cookie
 * alongside the HttpOnly `__Host-mft_session` session cookie, and every
 * POST, PUT, PATCH and DELETE request must echo it back as the
 * X-CSRF-Token header (internal/portal/csrf.go's RequireCSRF). The session
 * cookie itself stays HttpOnly and is never read here.
 *
 * GET /session/me and every login response also carry the same token in
 * the response body (`csrfToken` field, the Me schema in
 * docs/api/portal-api.yaml). This module keeps a copy of the most recent
 * one in memory as a fallback for the brief window right after login, in
 * case the cookie has not propagated to `document.cookie` yet when the
 * next request fires; the cookie is still the primary, documented source.
 */
export const CSRF_COOKIE_NAME = "mft_csrf";
export const CSRF_HEADER_NAME = "X-CSRF-Token";

let inMemoryFallback: string | undefined;

/** Called after every successful /login and /me response (httpClient.ts). */
export function rememberCsrfToken(token: string): void {
  inMemoryFallback = token;
}

function readCsrfCookie(): string | undefined {
  const prefix = `${CSRF_COOKIE_NAME}=`;
  const cookie = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(prefix));
  return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : undefined;
}

export function readCsrfToken(): string | undefined {
  return readCsrfCookie() ?? inMemoryFallback;
}
